import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import figure3 from "../../../../assets/images/weighing/scan/qr-escaner tablet.png";
import figure4 from "../../../../assets/images/weighing/scan/qr-escaner movil.png";
import Menu from "../../../../components/layout/menu";
import figure5 from "../../../../assets/images/weighing/register/qr-registro tablet.png";
import ReactQrScanner from "react-qr-scanner";
import { getVisits} from "../../../../client/administration/list/index";
import { getEvents} from "../../../../client/administration/event/index";

export default function IngresoQR() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScanning, setIsScanning] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Función para manejar la detección del QR
  const handleScan = async (data) => {
    if (data) {
      try {
        const decodedData = JSON.parse(data.text); // Intenta parsear el QR como JSON
        console.log("QR escaneado:", decodedData);

        const visitId = parseInt(decodedData.id_visita, 10);

        const visitsResponse = await getVisits();
       // console.log("Respuesta de visitas:", visitsResponse);

        const eventsResponse = await getEvents();
      //  console.log("Respuesta de eventos:", eventsResponse);

        const visitsData = visitsResponse.data;
                
        const matchingVisit = visitsData.find(visit => visit.idVisiTasa === visitId)
      //  console.log("QR VISITA COINCIDENTE:", matchingVisit)

        const matchingEvent = eventsResponse.data.find(event => 
          event.visit.idVisiTasa === visitId && event.ouputWeighting === null);

        if (matchingEvent){
         console.log("PRODUCTO:", matchingEvent.product.productName)
         const savedProduct = matchingEvent.product.productName;
         console.log("prod:",savedProduct);

         const savedWagonPlate = matchingEvent.wagonPlate;
         console.log("wagon plate:", savedWagonPlate);

         const savedBaggingCode = matchingEvent.baggingCode;
         console.log("bagging code:", savedBaggingCode);

         const savedContainer = matchingEvent.container;
         console.log("container:", savedContainer);

         const savedRemissionGuide = matchingEvent.visit.remissionGuide;
         console.log("guia de remision:", savedRemissionGuide);

          navigate("/registro-ticket", {state: {qrData:decodedData, isSalida: true, savedProduct, savedWagonPlate, savedBaggingCode, savedContainer, savedRemissionGuide}});
        } else{
          navigate("/registro-ticket", {state: {qrData: decodedData}});
        }

      } catch (err) {
        console.error("Error al parsear el QR:", err);
        navigate("/registro-ticket", { state: { qrData: data.text } }); // Redirige con texto plano
      }
      setIsScanning(false);
    }
  };

  const handleError = (err) => {
    console.error("Error al escanear:", err);
  };

  const constraints = {
    video: { facingMode: 'environment' },
  };

  return (
    <div className="flex w-full h-screen">
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div
        className={`flex-1 transition-all duration-300 ml-0 ${
          isMenuOpen ? "lg:ml-[100px] sm:ml-[0] md:ml-[0]" : "ml-0"
        } w-[84%]`}
      >
        <div className="relative z-10 flex justify-center w-full min-h-screen bg-center bg-cover bg-ingreso-movil md:bg-ingreso-tablet">
          {isScanning ? (
            <ReactQrScanner
              delay={300}
              onScan={handleScan}
              onError={handleError}
              constraints={constraints}
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                          w-[308px] h-[308px] md:w-[472px] md:h-[472px] lg:w-[350px] lg:h-[350px] xl:w-[300px] xl:h-[300px] rounded-lg"
            />
          ) : (
            <img
              src={figure5}
              alt="Centro"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 
                        w-[308px] h-[308px] md:w-[472px] md:h-[472px] lg:w-[350px] lg:h-[350px] xl:w-[300px] xl:h-[300px]"
            />
          )}

          <div className="relative z-50">
            <div className="flex items-end justify-center">
              <div className="absolute bottom-9 md:bottom-8 xl:bottom-2 lg:bottom-3 2xl:bottom-3">
                <button
                  onClick={() => setIsScanning(!isScanning)} // Inicia o detiene el escaneo
                  className="relative w-[75.94px] h-[75.94px] md:w-[120px] md:h-[120px] 
                            lg:w-[100px] lg:h-[100px] xl:w-[70px] xl:h-[70px] 
                            rounded-full bg-gradient-to-r from-[#76A140] to-[#C0D4A7] 
                            flex justify-center items-center shadow-[8px_10px_30px_#000000]"
                >
                  <img
                    src={figure3}
                    alt="Escanear"
                    className="hidden md:block w-[50px] h-[50px] lg:w-[45px] lg:h-[45px] xl:w-[30px] xl:h-[30px]"
                  />
                  <img
                    src={figure4}
                    alt="Escanear"
                    className="block md:hidden w-[31.64px] h-[31.64px] lg:w-[28px] lg:h-[28px] xl:w-[25px] xl:h-[25px]"
                  />
                </button>
                <p className="text-white text-[16px] md:text-[24px] lg:text-[20px] xl:text-[14px] mt-3 font-itcbold text-center">
                  Escanear
                </p>
              </div>
            </div>
          </div>

          <div
            className="absolute bottom-0 left-0 w-full bg-[#007696] rounded-tl-[60px] rounded-tr-[60px] z-40 
                      h-[180px] md:h-[225px] lg:h-[164px] xl:h-[125px] 2xl:h-[150px]"
          ></div>
        </div>
      </div>
    </div>
  );
}
